import ZanifyLogo from '../assets/images/zanifylogo.png';
import React from "react";

function Footer() {    
    const currentYear = new Date().getFullYear(); 

    return (
        <footer className="main-footer primary-bg">
            <div className="container">
                <div className="columns is-vcentered">
                    {/* Left Column: Social Media Icons */}
                    <div className="column is-one-third has-text-left">
                        <div className="social-icons">
                            <a href="https://www.facebook.com/cfcmministry/" className="icon-circle" aria-label="Facebook" target="_blank" rel="noreferrer">
                                <i className="fab fa-facebook"></i>
                            </a>
                            <a href="https://instagram.com" className="icon-circle" aria-label="Instagram" target="_blank" rel="noreferrer">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://x.com/commissionersm" className="icon-circle" aria-label="Twitter" target="_blank" rel="noreferrer">
                                <i className="fab fa-twitter"></i>
                            </a>
                            <a href="https://www.youtube.com/@commissionersforchristmini3727" className="icon-circle" aria-label="Twitter" target="_blank" rel="noreferrer">
                                <i className="fab fa-youtube"></i>
                            </a>
                        </div>
                    </div>

                    {/* Center Column: Copyright Text */}
                    <div className="column is-one-third has-text-centered has-text-white">
                        <p>&copy; {currentYear} Commissioners For Christ Ministry. <br/> All rights reserved.</p>
                    </div>

                    {/* Right Column: Developer Credit */}
                    <div className="column is-one-third has-text-right">
                        <a 
                            href="https://zanifytech.com" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="dev-logo-link"
                        >
                            <span className="dev-text">Developed By</span>
                            <div className="logo-container">
                                <img 
                                    src={ZanifyLogo}
                                    alt="Zanify Technologies"
                                    className="zanify-logo"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;